import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import EntitiesSideBar from "../components/entities/siderbar/EntitiesSideBar";
import "../components/entities/entities.scss";
import Layout from "../Layout";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";
import { fetchGeneralInformation } from "../components/entities/general-information/generalInformationSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "~/components/global-entities/globalEntitiesSlice";

const EntityContext = createContext();

const Entities = () => {
  const location = useLocation();
  const { id } = useParams();
  const activeTab =
    location.pathname.split("/entities")[2] || "general-information";
  const generalInformation = useSelector(
    (state) => state.generalInformation.generalInformation,
  );
  const allEntityservices = useSelector(
    (state) => state.globalEntities.entityservices,
  );
  const entityPlusService = allEntityservices.find(
    (service) => service.name === "Entities +",
  );

  const entityActiveServices = generalInformation?.data?.active_services;
  const [isEntityPlusActive, setIsEntityPlusActive] = useState(false);
  const [entity, setEntity] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const fetchEntityDetails = async () => {
    dispatch(fetchGeneralInformation(id));
  };
  const generalInformationStatus = useSelector(
    (state) => state.generalInformation.status,
  );
  useEffect(() => {
    if (generalInformationStatus === "succeeded") {
      setLoading(false);
    } else if (generalInformationStatus === "loading") {
      setLoading(true);
    }
  }, [generalInformationStatus]);
  useEffect(() => {
    fetchEntityDetails(id);
  }, [id]);
  useEffect(() => {
    if (generalInformation?.data) {
      setEntity(generalInformation?.data);
    }
  }, [generalInformation]);

  useEffect(() => {
    dispatch(fetchServices());
  }, []);
  useEffect(() => {
    const hasEntityPlus = entityActiveServices?.some(
      (service) => service.id === entityPlusService?.id,
    );
    setIsEntityPlusActive(hasEntityPlus);
  }, [generalInformation, entityActiveServices, entityPlusService]);
  return (
    <EntityContext.Provider value={{ loading, entity }}>
      <Layout
        title={
          !loading ? entity.name : <Skeleton width="10rem" height="1.5rem" />
        }
        crumbs={[
          { label: "My Entities", url: "/entities" },
          {
            label: (
              <div className="flex">
                {!loading ? (
                  entity?.name
                ) : (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                )}
                {!loading ? (
                  " "
                ) : (
                  <Skeleton width="10px" height="20px" className="mr-1" />
                )}
                {!loading ? (
                  <>
                    (
                    <ReactCountryFlag
                      countryCode={entity?.country || ""}
                      svg
                      className=""
                    />{" "}
                    {getName(entity?.country || "")})
                  </>
                ) : (
                  <Skeleton width="150px" height="20px" className="mr-1" />
                )}
              </div>
            ),
            id: "entity",
            url: `/entity/${id}/dashboard`,
          },
          { label: "Core Entity Data", id: "core-entity-data" },
        ]}
      >
        <div className="grid grid-nogutter">
          <div className="col-12 Entities-container">
            <div className="grid">
              <div className="col-3">
                <EntitiesSideBar
                  activeTab={activeTab}
                  setActiveTab={() => {}}
                  isEntityPlusActive={isEntityPlusActive}
                />
              </div>
              <div className="col-9">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </EntityContext.Provider>
  );
};
export default Entities;
export const useEntity = () => useContext(EntityContext);
